<div class="container-fluid p-0">
    <div class="row m-0">
        <div class="header p-0">
            <app-country />
        </div>
        <div class="main-content" [class.main-content-start]="((isNotBusinessDocs() && isNotPersonalDocs()) && !isOrderPage()) && !hasSidebar()">
            <app-header />
            <router-outlet />
        </div>
        <div class="header p-0" [class.ultra-wide-only]="(!isNotBusinessDocs() || !isNotPersonalDocs() || isOrderPage() || hasSidebar())">
            <app-state [stateCode]="stateCode()" [showSelectState]="showSelectState()" />
        </div>
        <app-footer />

        @if (isRouting() || orderSelection.isLoadingPrices() || orderProcessing.isUploading()) {
            <div class="global-loader-overlay">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        }
    </div>
</div>